export default "__VITE_PUBLIC_ASSET__7b6e19e9__"